import moment from 'moment';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/notification';

export default {
  getForPeriod(startDate, endDate, forRegion) {
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forRegion=${(forRegion ? forRegion : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  create(dto) { // Takes an allocation
      return new Promise(function(resolve, reject) {        
        AppUsersClient.post(`${resource}`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  update(dto) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(`${resource}`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete(notificationId, updateTag) {    
    return new Promise(function(resolve, reject) {      
      AppUsersClient.delete(`${resource}/${notificationId}/${updateTag}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getNotificationFromAllocation(id) {    
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/getNotificationFromAllocation/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
